import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { handlerChangeTabThreadChat } from '../handler/ChatThreadHandler';

export const DialogConfirmChangeTabChat = props => {
    const onHandlerCancel = () => {
        props.setIsOpenConfirmChangeThread(false);
    };

    const onHandlerConfirmChange = async () => {
        props.setIsOpenConfirmChangeThread(false);
        props.setIsEditedMsgInprogress(false);
        await handlerChangeTabThreadChat(props.changeToThread, props, props?.selectedProjectId);
    };

    return (
        <Dialog
            open={props.isOpenConfirmChangeThread}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{I18n.get('COMMSG048')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={onHandlerConfirmChange}
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                >
                    {I18n.get('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onHandlerCancel}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
